import { useEffect, useState } from 'preact/hooks';
import { useI18n } from '../i18n';

// Single global toast surface. Reads `?toast=<key>` from the URL on mount,
// resolves the key against the i18n bundle, shows for ~4s, then strips the
// param so a reload doesn't replay the message. The backend uses this to
// communicate OAuth-cancel back to the SPA without rendering raw JSON.
export function Toast() {
  const { t } = useI18n();
  const [msg, setMsg] = useState<string | null>(null);

  useEffect(() => {
    const url = new URL(location.href);
    const key = url.searchParams.get('toast');
    if (!key) return;
    const text = t(`toast.${key}`);
    if (text && text !== `toast.${key}`) {
      setMsg(text);
    }
    url.searchParams.delete('toast');
    history.replaceState(null, '', url.pathname + url.search + url.hash);
    const id = setTimeout(() => setMsg(null), 4000);
    return () => clearTimeout(id);
  }, []);

  if (!msg) return null;
  return (
    <div class="toast" role="status">
      {msg}
    </div>
  );
}
